import { createRouter, createWebHistory } from "vue-router";
import store from "../store";

const routes = [
  {
    name: "guest",
    path: "/login",
    component: () => import("../components/layouts/GuestView.vue"),
    meta: {
      middleware: "guest",
    },
    children: [
      {
        path: "",
        name: "login",
        component: () => import(/* webpackChunkName: "sign-in" */ "../views/auth/LoginView.vue"),
        meta: {
          title: `LogIn`,
        },
      },
      
      {
        path:"/login-password",
        name: "login-password",
        component: () => import(/*webpackChunkName: "login-password"*/ "../views/auth/LoginPasswordView.vue"),
      },

      {
        path: "/sign-up",
        name: "signup",
        component: () => import(/* webpackChunkName: "sign-up" */ "../views/auth/SignUpView.vue"),
        meta: {
          title: `Sign Up`,
        },
      },
      {
        path: "/otp-verification",
        name: "otpverification",
        component: () => import(/* webpackChunkName: "otp-verify" */ "../views/auth/OtpVerifyView.vue"),
        meta: {
          title: `OTP Verification`,
        },
      },
      {
        path: "/account-creation-success",
        name: "accountcreationsuccess",
        component: () => import(/* webpackChunkName: "account-creation-success" */ "../views/auth/AccountSuccessView.vue"),
        meta: {
          title: `Account Creation Success`,
        },
      },
      {
        path: "/forgot-password",
        name: "forgotPassword",
        component: () => import(/* webpackChunkName: "forgot-password" */ "../views/auth/ForgotPasswordView.vue"),
        meta: {
          title: `Forgot Password`,
        },
      },
      {
        path: "/forget/otp/verification",
        name: "passwordotpverification",
        component: () => import(/* webpackChunkName: "otpverification" */ "../views/auth/PasswordOtpVerifyView.vue"),
        meta: {
          title: "Password OTP Verification",
        },
      },
      {
        path: "/change/password",
        name: "changepassword",
        component: () => import(/* webpackChunkName: "forget" */ "../views/auth/ChangePasswordView.vue"),
        meta: {
          title: "Change Password",
        },
      },
      {
        path: "/password/reset/success",
        name: "savepassword",
        component: () => import(/* webpackChunkName: "successpassword" */ "../views/auth/SavePasswordSuccessView.vue"),
        meta: {
          title: "Save Password Success",
        },
      },
      {
        path: "/:pathMatch(.*)*",
        name: "pagesnotfound",
        component: () => import("../components/404NotFound.vue"),
      },
    ],
  },
  {
    name: "base",
    path: "/",
    component: () => import("../components/layouts/DefaultView.vue"),
    meta: {
      middleware: "auth",
      requiresAuth: true,
    },
    children: [
      {
        path: "/dashboard",
        name: "dashboard",
        component: () => import(/* webpackChunkName: "home" */ "../views/profile/HomeView.vue"),
        meta: {
          title: `Dashboard`,
        },
      },
      {
        path: "/device",
        name: "device",
        component: () => import(/* webpackChunkName: "device" */ "../views/profile/DeviceView.vue"),
        meta: {
          title: `Device`,
        },
      },
      {
        path: "/subscription",
        name: "subscription",
        component: () => import(/* webpackChunkName: "subscription" */ "../views/profile/SubscriptionView.vue"),
        meta: {
          title: `Subscription`,
        },
      },
      {
        path: "/billing-history",
        name: "billinghistory",
        component: () => import(/* webpackChunkName: "billinghistory" */ "../views/profile/BillingHistoryView.vue"),
        meta: {
          title: `Billing History`,
        },
      },
      {
        path: "/profile-change-password",
        name: "profilepasswordchange",
        component: () => import(/* webpackChunkName: "changepassword" */ "../views/profile/ChangePasswordView.vue"),
        meta: {
          title: `Change Password`,
        },
      },
      {
        path: "/subscription/price-list",
        name: "pricelist",
        component: () => import(/* webpackChunkName: "pricelist" */ "../views/profile/PriceListView.vue"),
        meta: {
          title: `Price List`,
        },
      },

      {
        path: "/checkout",
        name: "checkout",
        component: () => import(/* webpackChunkName: "checkout" */ "../views/profile/CheckoutView.vue"),
        meta: {
          title: `checkout`,
        },
      },

      {
        path:"/purchase/success",
        name: "purchaseSucess",
        component: () => import(/* webpackChunkName: "purchaseSucess" */ "../views/profile/PurchaseSuccessView.vue"),
        meta: {
          title: `Purchase Success`,
        },
      },
      {
        path:"/purchase/failed",
        name: "purchaseFailed",
        component: () => import(/* webpackChunkName: "PurchaseFailed" */ "../views/profile/PurchaseFailedView.vue"),
        meta: {
          title: `Purchase Failed`,
        },
      },

      {
        path:"/purchase/cancel",
        name: "purchaseCancel",
        component: () => import(/* webpackChunkName: "PurchaseCancel" */ "../views/profile/PurchaseCancelView.vue"),
        meta: {
          title: `Purchase Cancel`,
        },
      },

      
    ],
  }
];

const router = createRouter({
  scrollBehavior() {
    return { top: 0, left: 0 };
  },
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

router.beforeEach((to, from, next) => {
  document.title = to.meta.title || "Default Title";
  const auth = store.state.auth.status.loggedIn;
  if (to.path === "/") {
    if (auth) {
      return next({ name: "dashboard" });
    } else {
      return next({ name: "login" });
    }
  }
  if (to.meta.middleware === "guest") {
    if (auth) {
      next({ name: "dashboard" });
    } else {
      next();
    }
  } else if (to.meta.requiresAuth) {
    if (!auth) {
      next({ name: "login", query: { from: to.path } });
    } else {
      next();
    }
  } else {
    next();
  }
});

export default router;